export default {
    formData: {
        title: "Contact us",
        labels: {
            firstName: "First name",
            surname: "Surname",
            email: "Email",
            telephone: "Telephone",            
            subject: "Subject",
            enquiry: "Enquiry",
            capture: "capture",            
        },
        placeholders: {
            firstName: "Enter your full name",
            surname: "Enter Surname",
            email: "enter email e.g email@example.com",
            telephone: "Enter your telephone number", 
            subject: "Enter short title for your enquiry",                                   
            enquiry: "Please describe your enquiry or comment in details "
        },
        button: {
            text: "Submit",
        }        

    },
};
